import { Box, List, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { IUserData } from '../../service/deviceListService';
import { UserListPopupWrapper, UserPopUpWrapper } from './home-styles';
import ProfileView from './profile-view';
import { IUserListPopup } from './type';

export const UserDetailListPopup = ({ anchorEl, closePopup, userList }: IUserListPopup) => {
    const { t } = useTranslation();
    const open = Boolean(anchorEl);
    const getStatus = (status: number): ReactElement => {
        if (status === 0) return <Typography className="userStatusText">{`${t('inActive')}`}</Typography>;
        if (status === 1)
            return <Typography className="userStatusText userStatusActiveText">{`${t('active')}`}</Typography>;
        return <Typography className="userStatusText">{`${t('deleted')}`}</Typography>;
    };
    return (
        <UserPopUpWrapper
            open={open}
            anchorEl={anchorEl}
            onClose={closePopup}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top', // opposite of anchorOrigin
                horizontal: 'center', // aligns from user's point of view
            }}
            sx={{
                mt: 2.3,
                borderRadius: '16px',
            }}
        >
            <Box className="detailContainer">
                <List>
                    <Typography px={2} py={1} fontWeight="bold">
                        {t('customer_details')}
                    </Typography>
                    <Stack className="cards">
                        {userList.map((item: IUserData) => {
                            if (!item || item == null) return null;
                            const { profile_image, id, first_name, last_name, status } = item ?? {};
                            return (
                                <UserListPopupWrapper alignItems="center" key={id}>
                                    <Stack flexDirection="row" mb={2} alignItems="center" width={200} key={id}>
                                        <ProfileView
                                            key={id}
                                            profile_image={profile_image}
                                            className="userProfilePic"
                                        />
                                        <Stack>
                                            <Typography
                                                sx={{
                                                    width: '100%',
                                                    textAlign: 'left',
                                                    paddingLeft: '12px',
                                                    fontSize: '12px',
                                                    fontFamily: 'Caption/Regular',
                                                }}
                                            >{`${first_name} ${last_name}`}</Typography>
                                            {getStatus(status)}
                                        </Stack>
                                    </Stack>
                                </UserListPopupWrapper>
                            );
                        })}
                    </Stack>
                </List>
            </Box>
        </UserPopUpWrapper>
    );
};

export default UserDetailListPopup;
